import { render, staticRenderFns } from "./indexWtxh.vue?vue&type=template&id=0f6826e8&scoped=true"
import script from "./indexWtxh.vue?vue&type=script&lang=js"
export * from "./indexWtxh.vue?vue&type=script&lang=js"
import style0 from "./indexWtxh.vue?vue&type=style&index=0&id=0f6826e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6826e8",
  null
  
)

export default component.exports